import { useEffect } from "react";
import Image from "../components/Image";
import gsap from "gsap";
import { Power3 } from "gsap";

gsap.registerPlugin(Power3);

function Hero() {
  useEffect(() => {
    const entranceAnim = gsap.timeline();
    entranceAnim
      .from(".front-ocean", {
        duration: 2,
        y: "-300px",
        scaleY: 1.1,
        ease: Power3.easeInOut,
      })
      .from(
        ".passage-hero",
        {
          duration: 2,
          y: "120px",
          ease: Power3.easeInOut,
        },
        "<"
      )
      .from(
        ".back-ocean",
        {
          duration: 2,
          y: "150",
          ease: Power3.easeInOut,
        },
        "<"
      )
      .from(
        ".sky",
        {
          duration: 2,
          y: "350",
          ease: Power3.easeInOut,
        },
        "<"
      );

    const heroAnimation = gsap.timeline({
      scrollTrigger: {
        trigger: ".hero",
        start: "top top",
        end: "+=1000",
        scrub: 1,
      },
    });
    heroAnimation
      .to(".front-ocean", {
        duration: 5,
        y: "-250px",
      })
      .to(
        ".passage-hero",
        {
          duration: 5,
          y: "100px",
        },
        "<"
      )
      .to(
        ".back-ocean",
        {
          duration: 5,
          y: "150",
        },
        "<"
      )
      .to(
        ".sky",
        {
          duration: 5,
          y: "350",
        },
        "<"
      )
      .to(".front-ocean", {
        duration: 5,
        scaleY: 1.1,
        y: "-300",
      })
      .to(
        ".diagonals",
        {
          duration: 5,
          scaleY: "1.3",
          y: "-40px",
        },
        "<"
      )
      .to(
        ".passage-hero",
        {
          duration: 5,
          y: "150px",
        },
        "<"
      )
      .to(
        ".sky",
        {
          duration: 5,
          y: "400",
        },
        "<"
      );
  }, []);

  return (
    <div className="hero-content w-full h-screen sticky top-0">
      <Image
        containerCss={"diagonals absolute bottom-0 left-0 -z-0"}
        src={
          "https://res.cloudinary.com/dl5mqatis/image/upload/v1647865903/passage/ocean/621f585d8c0579e3ec2db271_Group_761_mahkvb.png"
        }
      />
      <Image
        containerCss={
          "front-ocean absolute top-[-250px] left-0 -z-10 w-full flex"
        }
        imgCss={"w-full"}
        src={
          "https://res.cloudinary.com/dl5mqatis/image/upload/v1647874923/passage/ocean/ocean-front-min_xujz8t.png"
        }
      />
      <div className="passage-hero absolute bottom-20 left-0 w-full h-screen -z-20 flex flex-col justify-center items-center">
        <div className=" w-1/2">
          <Image
            containerCss={"w-full"}
            src={
              "https://res.cloudinary.com/dl5mqatis/image/upload/v1644224875/passage/passage_myfxm9.png"
            }
          />
          <p className=" w-full text-3xl text-center text-slate-50 top-">
            FINALLY, A SOLUTION THAT EMPOWERS PACIFIC ISLAND NATIONS, AND REMOTE
            COMMUNITIES, TO TAKE BACK CONTROLS ON THEIR THIER PRECIOUS
            RESOURCES, ON THEIR OWN TERMS.{" "}
          </p>
        </div>
      </div>
      <Image
        containerCss={"back-ocean absolute bottom-0 left-0 -z-30 w-full flex"}
        imgCss={"w-full"}
        src={
          "https://res.cloudinary.com/dl5mqatis/image/upload/v1647874923/passage/ocean/ocean-background-min_dwqx1l.png"
        }
      />
      <Image
        containerCss={"sky absolute bottom-0 left-0 -z-40 w-full flex"}
        imgCss={"w-full"}
        src={
          "https://res.cloudinary.com/dl5mqatis/image/upload/v1647874923/passage/ocean/sky-min_mavqer.png"
        }
      />
    </div>
  );
}

export default Hero;
